import { render, staticRenderFns } from "./CopyChanges.vue?vue&type=template&id=0d4e1588&"
import script from "./CopyChanges.vue?vue&type=script&lang=ts&"
export * from "./CopyChanges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports